module.exports = __webpack_public_path__ + "static/media/predictiveMarketing.663541ad.svg";